import * as React from "react";
import { connect } from 'react-redux';
import * as actionTypes from '../../store/actionTypes';
import { BrowserRouter, Route, Link, NavLink, Redirect, withRouter } from "react-router-dom";
import NotificationComponent from './notificationComponent';
import logo01white from "../../assets/images/logos/Logo-01-white.png";
import AuthService from '../../services/authService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faBars, faChevronLeft, faSearch, faSignOutAlt, faUser, faTablets, faPills } from '@fortawesome/free-solid-svg-icons';
import Drawer from '@material-ui/core/Drawer';
import MenuNavigation from '../navigation/menuNavigation';
import * as Constants from '../../common/constants';
import Badge from '@material-ui/core/Badge';
import { MuiThemeProvider, Tooltip } from '@material-ui/core';
import UserService from "../../services/userService";
import Growl from '../../common/components/alertMessage/growl';
import Translate from '../../common/functions/translate';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import AlphabeticalFilter from '../../common/components/alphabeticalFilter/alphabeticalFilter';
import ConfirmDialog from '../../common/components/confirmDialog/confirmDialog';
import { constants } from "http2";

interface IProps {
  onSearchLetterClick: any,
  onSearchNameClick: any,
  lang: string,
  isUserLogged: boolean,
  history: any,
  isNotificationUpdated: boolean,
  setNotifications: any,
  classes: any,
  onUserLogout: any,
  isUserJustLogged: boolean,
  setUserJustLoggedToFalse: any
}

interface IState {
  searchText: string,
  isDrawerOpen: boolean,
  notificationsCount: number,
  isLoading: boolean,
  isAuthenticated: boolean,
  isNotificationDrawerOpen: boolean,
  scroll: any,
  isSearchDrawerOpen: boolean,
  isVisibleConfirmDialog: boolean,
}

class HeaderComponent extends React.Component<IProps, IState> {
  userService = new UserService();
  authService = new AuthService();
  growl: any;
  intervalId: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      searchText: '',
      isDrawerOpen: false,
      notificationsCount: 0,
      isLoading: false,
      isAuthenticated: this.authService.isAuthenticated(),
      isNotificationDrawerOpen: false,
      scroll: null,
      isSearchDrawerOpen: false,
      isVisibleConfirmDialog: false
    }
  }

  componentDidMount() {
    if (this.authService.isAuthenticated()) {
      this.getNotifications();
      this.repeatGetData();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isUserLogged != this.props.isUserLogged && this.authService.isAuthenticated()) {
      this.setState({
        isAuthenticated: this.authService.isAuthenticated()
      }, () => this.updateNotifications())
    }

    if (prevProps.isNotificationUpdated != this.props.isNotificationUpdated) {
      if (this.authService.isAuthenticated()) {
        this.updateNotifications();
      }
    }
    if (this.props.isUserJustLogged) {
      this.growl.show({ severity: 'success', summary: Translate('You have successfully logged in.'), life: 5000 });
      this.props.setUserJustLoggedToFalse();
    }
  }

  getNotifications = () => {
    if (this.state.isAuthenticated && this.authService.isAuthenticated()) {
      this.userService.getAllUserNotifications(this.props.lang)
        .then(
          (data) => {
            if (data != this.state.notificationsCount) {
              this.setState({
                notificationsCount: data
              });
            }
            if (this.props.isNotificationUpdated) {
              this.props.setNotifications();
            }
          },
          error => {
            this.growl.show({ severity: 'error', summary: error.message });
          }
        );
    }
    else {
      this.clearInterval();
    }
  }

  repeatGetData = () => {
    let interval = 1 * 60 * 1000;
    this.intervalId = setInterval(() => {
      if (this.authService.isAuthenticated()) {
        this.getNotifications();
        this.authService.checkForRefreshToken();
      }
    }, interval);
  }

  clearInterval = () => {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  updateNotifications = () => {
    this.clearInterval();
    if (this.authService.isAuthenticated()) {
      this.getNotifications();
      this.repeatGetData();
    }
  }

  handleAlphaIndexChange = (e, letter: string) => {
    e.preventDefault();
    this.setState({ isSearchDrawerOpen: false });
    this.props.onSearchLetterClick(letter);
  }

  handleChange = (key, value) => {
    this.setState({ searchText: value });
  };

  handleSearchButtonClick = () => {
    const { searchText } = this.state;
    if (searchText) {
      this.setState({ isSearchDrawerOpen: false })
      this.props.onSearchNameClick(searchText);
    }
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.setState({ isSearchDrawerOpen: false })
      this.handleSearchButtonClick();
    }
  }

  handleBackClick = (e) => {
    e.preventDefault();
    this.props.history.goBack();
  }

  notificationError = (error) => {
    this.setState({ isNotificationDrawerOpen: false });
    this.growl.show({ severity: 'error', summary: error.message });
  }

  openNotificationDrawer = () => {
    //if (this.state.notificationsCount > 0) {
    this.setState({ isNotificationDrawerOpen: true });
    //}
  }

  handleLogout = () => {
    this.setState({
      isVisibleConfirmDialog: true
    });
  }

  logoutConfirmClick = () => {
    this.authService.logout();
    this.props.onUserLogout();
    this.props.history.push('/');
    this.setState({
      isVisibleConfirmDialog: false,
      isAuthenticated: this.authService.isAuthenticated()
    })
  }

  handleLogin = () => {
    this.props.history.push('/login');
  }

  render() {
    const { searchText, notificationsCount, isLoading } = this.state;
    const SearchContent = React.forwardRef((props, ref) => <FontAwesomeIcon size={window.innerWidth < Constants.device.desktop ? '1x' : 'lg'} icon={faSearch} />);
    const NotificationContent = React.forwardRef((props, ref) => <Badge badgeContent={notificationsCount} color="secondary" onClick={this.openNotificationDrawer}>
      <FontAwesomeIcon size={window.innerWidth < Constants.device.desktop ? '1x' : 'lg'}
        style={{ verticalAlign: 'text-top' }} icon={faBell}></FontAwesomeIcon>
    </Badge>);
    const LogoutContent = React.forwardRef((props, ref) => <FontAwesomeIcon icon={faSignOutAlt} size="lg" />);
    const LoginContent = React.forwardRef((props, ref) => <FontAwesomeIcon icon={faUser} size="lg" />);

    const backButton = location.pathname != '/' ?
      <div className="app-header-item back-button" onClick={(e) => this.handleBackClick(e)}>
        <FontAwesomeIcon icon={faChevronLeft} />
      </div>
      : null;

    return (
      <>
        <Growl ref={(el) => this.growl = el} />
        <div style={{ backgroundColor: '#2b415f', width: '100%', height: 54, position: 'fixed', zIndex: 5 }}>
          <div className="app-header">

            <div className="app-header-left">
              {window.innerWidth < Constants.device.desktop ? backButton :
                <>
                  {backButton}
                  <div className="app-header-item user-menu-web" style={{ display: 'inline' }} onClick={() => this.setState({ isDrawerOpen: true })}>
                    <FontAwesomeIcon icon={faBars} size="lg" />
                  </div>
                  <NavLink to="/medicines">
                    <div className="app-navigation-item">
                      {window.innerWidth < Constants.device.desktop ?
                        <FontAwesomeIcon icon={faTablets} size="2x" style={{ margin: '5px' }} /> : null}
                      {Translate('Medicines')}
                    </div>
                  </NavLink>

                  <NavLink to="/interactions">
                    <div className="app-navigation-item">
                      {window.innerWidth < Constants.device.desktop ?
                        <FontAwesomeIcon icon={faPills} size="2x" style={{ margin: '5px' }} /> : null}
                      {Translate('Interactions')}
                    </div>
                  </NavLink>
                </>}
            </div>

            <div className="app-header-center">
              <Link to="/"><img src={logo01white} className="app-logo" alt="logo" /></Link>
            </div>

            <div className="app-header-right">

              <div className="app-header-item" style={{ /* background: '#2196f3' */ }} onClick={() => this.setState({ isSearchDrawerOpen: true })}>
                <Tooltip title={Translate("Search")}>
                  <SearchContent />
                </Tooltip>
              </div>

              {this.authService.isAuthenticated() ?
                <>
                  <div className="app-header-item">
                    <MuiThemeProvider theme={Constants.buttonSmallBadge}>
                      <Tooltip title={Translate("Notifications")}>
                        <NotificationContent />
                      </Tooltip>
                    </MuiThemeProvider>
                  </div>

                  <div className="app-header-item user-menu-web" onClick={this.handleLogout} >
                    <Tooltip title={Translate("Logout")}>
                      <LogoutContent />
                    </Tooltip>
                  </div>
                </>
                :
                <div className="app-header-item user-menu-web" onClick={this.handleLogin}>
                  <Tooltip title={Translate("Login")}>
                    <LoginContent />
                  </Tooltip>
                </div>}

              <div className="app-header-item user-menu" style={{ /* background: '#2196f3' */ }} onClick={() => this.setState({ isDrawerOpen: true })}>
                <FontAwesomeIcon icon={faBars} />
              </div>
            </div>

          </div>
        </div>
        <MuiThemeProvider theme={Constants.notificationDrawer}>
          <Drawer
            anchor="top"
            open={this.state.isNotificationDrawerOpen}
            onClose={() => this.setState({ isNotificationDrawerOpen: false })}
            onScroll={(el) => this.setState({ scroll: el.nativeEvent })}
          >
            <div
              className="drawer-notification-panel"
              tabIndex={0}
              role="button"
            >
              <NotificationComponent
                errorShow={this.notificationError}
                lang={this.props.lang}
                updateCount={this.updateNotifications}
                listElm={this.state.scroll}
                history={this.props.history}
                closeDrawer={() => this.setState({ isNotificationDrawerOpen: false })}
              />
            </div>
          </Drawer>
        </MuiThemeProvider>

        <Drawer
          anchor={window.innerWidth < Constants.device.desktop ? 'right' : 'left'}
          open={this.state.isDrawerOpen}
          onClose={() => this.setState({ isDrawerOpen: false })}>
          <div
            tabIndex={0}
            role="button"
            onClick={() => this.setState({ isDrawerOpen: false })}
            onKeyDown={() => this.setState({ isDrawerOpen: false })}>

            {/* 
            // @ts-ignore */}
            <MenuNavigation onDrawarMenuLogoutClick={this.handleLogout} />
          </div>
        </Drawer>

        <Drawer
          anchor="top"
          open={this.state.isSearchDrawerOpen}
          onClose={() => this.setState({ isSearchDrawerOpen: false })}
        >
          <div
            tabIndex={0}
            role="button"

          >
            <div className="user-condition-panel drawer-panel">
              <div className="user-condition-filter">
                <h3>{Translate('SearchMedicineInDatabase')}</h3>
                <Paper style={Constants.inputWithButton.root} elevation={1}>
                  <InputBase style={Constants.inputWithButton.input} placeholder={Translate('EnterMedicineName')}
                    onChange={(e) => this.handleChange('searchByName', e.target['value'])}
                    onKeyPress={this.handleKeyPress}
                    value={searchText ? searchText : ""}
                  />
                  <IconButton
                    color="primary"
                    style={Constants.inputWithButton.iconButton}
                    onClick={this.handleSearchButtonClick}
                  >
                    <SearchIcon />
                  </IconButton>
                </Paper>
              </div>
              <div className="user-condition-filter">
                <h4>{Translate('BrowseAlphabetically')}</h4>
                <AlphabeticalFilter
                  handleAlphaIndexChange={this.handleAlphaIndexChange}
                  filters={['en', 'bg']}
                  buttonStyle={true}
                  letterClassName="p-button-secondary p-button-raised"
                />
              </div>
            </div>
          </div>
        </Drawer>

        {this.state.isVisibleConfirmDialog ?
          <ConfirmDialog
            headerTitle={Translate("Logout")}
            isVisible={this.state.isVisibleConfirmDialog}
            yesClick={() => { this.logoutConfirmClick() }}
            noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
            {Translate("Are you sure you want to logout")}
          </ConfirmDialog>
          : null}
      </>
    )
  }
}

const mapsStateToProps = state => {
  return {
    lang: state.common.lang,
    isUserLogged: state.common.isUserLogged,
    isNotificationUpdated: state.common.isNotificationUpdated,
    isUserJustLogged: state.common.isUserJustLogged,
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onSearchNameClick: (medicineSearchName) => dispatch({ type: actionTypes.MEDICINE_SEARCH_BY_NAME, medicineSearchName: medicineSearchName }),
    onSearchLetterClick: (medicineSearchLetter) => dispatch({ type: actionTypes.MEDICINE_SEARCH_BY_LETTER, medicineSearchLetter: medicineSearchLetter }),
    onUserLogout: () => dispatch({ type: actionTypes.USER_LOGOUT }),
    setNotifications: () => dispatch({ type: actionTypes.SET_USER_NOTIFICATIONS }),
    setUserJustLoggedToFalse: () => dispatch({ type: actionTypes.SET_USER_JUST_LOGGED_TO_FALSE }),
  }
}

export default withRouter(connect(mapsStateToProps, mapDispatchToProps)(HeaderComponent));